import { apiUrl } from '../../../config/api';
function normalizeArray(value) {
    return Array.isArray(value) ? value : [];
}

function normalizeNombre(item) {
    if (typeof item === "string") {
        return item.trim();
    }

    return String(item?.jugador || item?.nombre || "").trim();
}

function normalizeNumeros(value) {
    if (Array.isArray(value)) {
        return value.filter(Boolean).map((item) => String(item).trim()).filter(Boolean);
    }

    if (value === null || value === undefined || value === "") {
        return [];
    }

    return [String(value).trim()].filter(Boolean);
}

function normalizeCampeonCount(value) {
    if (Array.isArray(value)) {
        return value.length;
    }

    if (typeof value === "number") {
        return value;
    }

    if (value && typeof value === "object") {
        return Object.keys(value).length > 0 ? 1 : 0;
    }

    return value ? 1 : 0;
}

function normalizeNacionalidad(item) {
    const rawNacionalidad = item?.nacionalidad ?? item?.pais ?? item?.nacion ?? item?.nationality;

    if (typeof rawNacionalidad === "string") {
        return rawNacionalidad.trim();
    }

    if (rawNacionalidad && typeof rawNacionalidad === "object") {
        return String(
            rawNacionalidad.nombre ??
                rawNacionalidad.name ??
                rawNacionalidad.pais ??
                rawNacionalidad.nacionalidad ??
                ""
        ).trim();
    }

    return "";
}

async function parseResponse(response) {
    if (!response.ok) {
        throw new Error(`Error! status: ${response.status}`);
    }

    const payload = await response.json();

    if (typeof payload === "string") {
        try {
            return JSON.parse(payload);
        } catch (error) {
            return payload;
        }
    }

    return payload;
}

// Module-level cache for jugadores listado to avoid re-fetching on remount
let jugadoresCache = null;
let jugadoresCachePromise = null;

async function loadJugadoresListado() {
    // Return from cache if available
    if (jugadoresCache !== null) {
        return jugadoresCache;
    }

    // Return existing fetch promise if already in flight (deduplication)
    if (jugadoresCachePromise !== null) {
        return jugadoresCachePromise;
    }

    // Start new fetch and track it
    jugadoresCachePromise = (async () => {
        const response = await fetch(apiUrl('listado/listadoJugadores'));
        const payload = normalizeArray(await parseResponse(response));

        const result = payload
            .map((item) => {
                const nombre = normalizeNombre(item);
                const numeros = normalizeNumeros(item?.numero);
                const campeonCount = normalizeCampeonCount(item?.campeon);
                const nacionalidad = normalizeNacionalidad(item);

                return {
                    nombre,
                    numeros,
                    nacionalidad,
                    isCampeon: campeonCount > 0,
                    campeonCount,
                };
            })
            .filter((item) => item.nombre)
            .sort((a, b) => a.nombre.localeCompare(b.nombre, "es"));

        // Cache successful result
        jugadoresCache = result;
        return result;
    })();

    try {
        return await jugadoresCachePromise;
    } finally {
        jugadoresCachePromise = null;
    }
}

export async function fetchListadoJugadores() {
    return loadJugadoresListado();
}
